import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'
import { Card } from '@/components/ui/card'
import {
  type ExtractionProgressStep,
  ProgressStepRow,
} from '@/components/extraction-progress-checklist'
import { buildTypeCStandardCheckExtractionSteps } from '../utils/buildTypeCStandardCheckExtractionSteps'
import type { TypeCStandardCheckTaskState } from '../utils/typeCStandardCheckTaskState'

function TypeCStandardCheckStepRows({ step }: { step: ExtractionProgressStep }) {
  const subRows = step.children
  if (subRows != null && subRows.length > 0) {
    const parentRow: ExtractionProgressStep = { ...step, children: undefined }
    return (
      <>
        <ProgressStepRow key={step.id} step={parentRow} nested={false} />
        {subRows.map((child) => (
          <ProgressStepRow key={child.id} step={child} nested={false} />
        ))}
      </>
    )
  }

  return <ProgressStepRow key={step.id} step={step} nested={false} />
}

export function TypeCStandardCheckProgress({
  state,
  className,
}: {
  state: TypeCStandardCheckTaskState
  className?: string
}) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const steps = useMemo(
    () => buildTypeCStandardCheckExtractionSteps(state, t),
    [state, t]
  )

  const headingLabel = t('onboarding.typeCStandardCheckDiscovery.heading')

  return (
    <Card
      className={cn(
        'rounded-lg border bg-card px-4 py-3 text-sm shadow-sm',
        className
      )}
      role='region'
      aria-label={headingLabel}
    >
      <ul className='space-y-3' role='list'>
        {steps.map((step) => (
          <TypeCStandardCheckStepRows key={step.id} step={step} />
        ))}
      </ul>
    </Card>
  )
}
